import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { navLinksdata } from "../../constants";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [animatedLogo, setAnimatedLogo] = useState(false);
  const [animatedLinks, setAnimatedLinks] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Trigger logo animation on component mount
    setTimeout(() => {
      setAnimatedLogo(true);
    }, 500);

    // Trigger nav links animation after logo
    setTimeout(() => {
      setAnimatedLinks(true);
    }, 1000);

    // Add scroll event listener
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`w-full h-full sticky top-0 z-50 mx-auto flex justify-between items-center font-titleFont py-6 px-8 backdrop-filter backdrop-blur-[10px] transition-all duration-300 
        ${
          scrolled
            ? "bg-[#0A0A14] bg-opacity-80 border-b-[1px] border-b-[rgba(75,0,110,0.5)]"
            : "bg-[#0A0A14] bg-opacity-90 border-b-[1px] border-b-[#4B006E]"
        }`}
    >
      <div className="font-bodyFont font-semibold text-lightText relative">
        <span
          className={`text-xl transition-all duration-1000 ${
            animatedLogo ? "opacity-100" : "opacity-0"
          }`}
        >
          {"IMTIAZPRANTO".split("").map((letter, index) => (
            <span
              key={index}
              className="inline-block transition-all duration-700"
              style={{
                animationDelay: `${index * 60}ms`,
                textShadow: animatedLogo
                  ? "0 0 8px rgba(138, 0, 212, 0.5), 0 0 12px rgba(138, 0, 212, 0.3)"
                  : "none",
                opacity: animatedLogo ? 1 : 0,
                transform: animatedLogo ? "translateY(0)" : "translateY(10px)",
                transition: `opacity 500ms ease ${
                  index * 60
                }ms, transform 500ms ease ${
                  index * 60
                }ms, text-shadow 500ms ease`,
              }}
            >
              {letter}
            </span>
          ))}
        </span>
      </div>
      <div className="flex items-center">
        <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
          {navLinksdata.map(({ _id, title, link }, index) => (
            <li
              className={`transition-all ${
                animatedLinks
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-4"
              }`}
              style={{
                transitionDelay: `${index * 100 + 100}ms`,
                transitionDuration: "500ms",
              }}
              key={_id}
            >
              <Link
                activeClass="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                className="font-sans font-normal text-base text-grayText tracking-[0.03em] px-4 py-2 mx-1 relative hover:bg-gradient-to-r hover:from-[#4B006E] hover:to-[#8A00D4] hover:bg-opacity-30 transition-all duration-300 hover:-translate-y-[2px] block"
              >
                {title}
                <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-[2px] bg-[#8A00D4] hover:w-[70%] transition-all duration-300"></span>
              </Link>
            </li>
          ))}
        </ul>
        <a
          href="/resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className={`hidden mdl:inline-flex ml-6 px-5 py-2 bg-gradient-to-r from-[#4B006E] to-[#8A00D4] text-white py-4 px-8 rounded-md shadow-[0_0_15px_rgba(138,0,212,0.5)] hover:shadow-[0_0_25px_rgba(138,0,212,0.7)] transition-all duration-300 ${
            animatedLinks ? "opacity-100" : "opacity-0"
          }`}
          style={{
            transitionDelay: `${navLinksdata.length * 100 + 200}ms`,
            transitionDuration: "500ms",
          }}
        >
          Resume
        </a>
        <span
          onClick={() => setShowMenu(!showMenu)}
          className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-[#8A00D4] cursor-pointer"
        >
          <FiMenu />
        </span>
        {showMenu && (
          <div className="w-[80%] h-screen overflow-scroll absolute top-0 left-0 bg-[#0A0A14] p-4 scrollbar-hide">
            <div className="flex flex-col gap-8 py-2 relative">
              <div>
                <h1 className="text-xl font-bodyFont font-semibold text-lightText">
                  {"IMTIAZPRANTO".split("").map((letter, index) => (
                    <span
                      key={index}
                      className="inline-block"
                      style={{
                        textShadow:
                          "0 0 8px rgba(138, 0, 212, 0.5), 0 0 12px rgba(138, 0, 212, 0.3)",
                      }}
                    >
                      {letter}
                    </span>
                  ))}
                </h1>
                <p className="text-sm text-gray-400 mt-2">
                  AI Product Strategist transforming SaaS & e-Commerce with
                  intelligent solutions.
                </p>
              </div>
              <ul className="flex flex-col gap-4">
                {navLinksdata.map((item, index) => (
                  <li
                    key={item._id}
                    style={{
                      animation: `fadeInRight 0.5s ease forwards ${
                        index * 0.1 + 0.2
                      }s`,
                      opacity: 0,
                    }}
                  >
                    <style jsx>{`
                      @keyframes fadeInRight {
                        from {
                          opacity: 0;
                          transform: translateX(20px);
                        }
                        to {
                          opacity: 1;
                          transform: translateX(0);
                        }
                      }
                    `}</style>
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className="font-sans font-normal text-base text-grayText tracking-[0.03em] px-4 py-2 mx-1 relative hover:bg-gradient-to-r hover:from-[#4B006E] hover:to-[#8A00D4] hover:bg-opacity-30 transition-all duration-300 hover:-translate-y-[2px] block"
                    >
                      {item.title}
                      <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-[2px] bg-[#8A00D4] hover:w-[70%] transition-all duration-300"></span>
                    </Link>
                  </li>
                ))}
              </ul>
              <a
                href="/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-[#4B006E] to-[#8A00D4] text-white py-4 px-8 rounded-md shadow-[0_0_15px_rgba(138,0,212,0.5)] hover:shadow-[0_0_25px_rgba(138,0,212,0.7)] transition-all duration-300 text-center"
              >
                Resume
              </a>
              <div className="flex flex-col gap-4">
                <h2 className="text-base uppercase font-titleFont mb-4">
                  Find me in
                </h2>
                <div className="flex gap-4">
                  <a
                    href="https://github.com/imtiaz-pranto"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bannerIcon"
                  >
                    <FaGithub />
                  </a>
                  <a
                    href="http://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bannerIcon"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>
              <span
                onClick={() => setShowMenu(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-[#8A00D4] duration-300 text-2xl cursor-pointer"
              >
                <MdClose />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
